/** Structured marketplace cancel / decline reason codes → display labels. */
const CANCEL_REASON_LABELS = {
  CHANGED_MIND: "Changed mind",
  ORDERED_BY_MISTAKE: "Ordered by mistake",
  TOO_LONG_WAIT: "Taking too long",
  WRONG_ITEMS: "Wrong items / details",
  OTHER: "Other",
  OUT_OF_STOCK: "Out of stock",
  RESTAURANT_CLOSED: "Restaurant closed",
  CANNOT_FULFILL: "Cannot fulfill",
  CUSTOMER_REQUEST: "Customer requested",
  AUTO_ACCEPT_TIMEOUT: "Auto-accept timeout",
  TOO_FAR: "Too far",
  VEHICLE_ISSUE: "Vehicle issue",
  UNSAFE_AREA: "Unsafe area",
  UNAVAILABLE: "Unavailable",
  CUSTOMER_REFUSED: "Customer refused",
  CUSTOMER_NOT_AVAILABLE: "Customer not available",
  WRONG_ADDRESS: "Wrong address",
  ACCESS_ISSUE: "Access issue",
  DAMAGED_ORDER: "Damaged order",
  RIDER_ISSUE: "Rider issue",
  CustomerCancelled: "Customer cancelled",
  RestaurantCancelled: "Restaurant cancelled",
  RestaurantRejected: "Restaurant rejected",
  Timeout: "Timeout",
  LegacyText: "Legacy (free text)",
  Unknown: "Unknown",
};

/**
 * @param {string|null|undefined} code
 * @returns {string}
 */
export function labelForCancelReasonCode(code) {
  const trimmed = (code ?? "").toString().trim();
  if (!trimmed) return "";
  return CANCEL_REASON_LABELS[trimmed] || trimmed;
}

/**
 * @param {string|null|undefined} type
 * @returns {string}
 */
export function labelForCancelledByType(type) {
  const t = (type ?? "").toString().trim();
  if (!t || t.toLowerCase() === "unknown") return "Unattributed";
  return t;
}

/**
 * Read a property that may be camelCase or PascalCase on API payloads.
 * @param {object|null|undefined} obj
 * @param  {...string} keys
 */
export function pickOrderField(obj, ...keys) {
  if (!obj) return null;
  for (const key of keys) {
    if (obj[key] != null && obj[key] !== "") return obj[key];
  }
  return null;
}

/**
 * Whether the order looks cancelled/rejected (or has cancel audit fields).
 * @param {object|null|undefined} order
 */
export function hasCancelAudit(order) {
  if (!order) return false;
  const status = (
    pickOrderField(order, "recvorder_status", "Recvorder_status") || ""
  )
    .toString()
    .trim()
    .toLowerCase();
  if (status === "cancelled" || status === "rejected") return true;
  return Boolean(
    pickOrderField(order, "cancelReasonCode", "CancelReasonCode") ||
      pickOrderField(order, "cancelledAt", "CancelledAt") ||
      pickOrderField(order, "cancelledByType", "CancelledByType")
  );
}
